import { useShopV3CartStore } from '@portal/state/store/cartStore';
import { createHashedEmailChangeEvent } from 'analytics/events';
import { logoutEvent } from 'analytics/events/studio';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { safeLocalStorage } from 'shared/utils/safeLocalStorage';
import { cartAtom, currentCartIdAtom } from 'state/cart/atoms';
import { removeSessionCookies } from 'state/cookies/sessionCookies';
import { useClearSession } from './useSession';

export const useLogout = () => {
  const clearSession = useClearSession();
  const [, setCartV2] = useAtom(cartAtom);
  const [, setCartId] = useAtom(currentCartIdAtom);
  const deleteCart = useShopV3CartStore((state) => state.actions.deleteCart);

  return useCallback(() => {
    clearSession();
    logoutEvent();
    createHashedEmailChangeEvent({ hashedCustomerEmail: null });
    removeSessionCookies();
    safeLocalStorage.removeItem('cartId');
    deleteCart();
    setCartV2(null);
    setCartId(null);
  }, [clearSession, deleteCart, setCartId, setCartV2]);
};
